import apiClient from '../clients/apiClient.js';

export function DownloadFile(file_id, filename) {
    return apiClient
        .get(`/library/get-file?file_id=${file_id}`)
        .then(async ({ data }) => {
        const fileUrl = data.file_url;
        var contentType = data.content_type;
        console.log("[Library] data from get file is", data)
        if (data.content_type == "application/octet-stream" && filename?.endsWith(".xlsx")) {
            contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        if (data.content_type == "binary/octet-stream" && filename?.endsWith(".xlsx")) {
            contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        
        if (contentType.startsWith("image/")) {
            window.open(fileUrl, "_blank")
        } else if (contentType === "application/pdf") {
            window.open(fileUrl)
        } else if (contentType.startsWith("text/") || contentType === "application/json") {
            const response = await fetch(fileUrl);
            const text = await response.text();
            return <pre>{text}</pre>;
        } else if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            // const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
            window.open(fileUrl, "_blank");
        } else {
            window.open(fileUrl)
        }
    });
};

export function DownloadFile2(fileId) {
    return apiClient
        .post('/library/library-actions', {
            action: "get_file",
            get_file: {
                file_id: fileId,
            }
        })
        .then(async ({ data }) => {
            console.log("[Library] data from get file is", data)
            if (data?.success) {
                const fileUrl = data.get_file?.download_url;
                var contentType = data.get_file?.file?.content_type;
                
                if (contentType?.startsWith("image/")) {
                    window.open(fileUrl, "_blank")
                } else if (contentType === "application/pdf") {
                    window.open(fileUrl)
                } else if (contentType?.startsWith("text/") || contentType === "application/json") {
                    const response = await fetch(fileUrl);
                    const text = await response.text();
                    return <pre>{text}</pre>;
                } else if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    // const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
                    window.open(fileUrl, "_blank");
                } else {
                    window.open(fileUrl)
                }
            }
    });
};

export default DownloadFile;